<template>
  <div>
    <Hero />
    <CallOut />
    <Video />
    <CallToAction />
  </div>
</template>
<script>
import Hero from "@/new-components/Hero.vue";
import CallOut from "@/new-components/CallOut.vue";
import Video from "@/new-components/Video.vue";
import CallToAction from "@/new-components/CallToAction.vue";
export default {
  name: "home",
  components: {
    Hero,
    CallOut,
    Video,
    CallToAction
  }
};
</script>
<style></style>
